import { render, staticRenderFns } from "./order_link.vue?vue&type=template&id=5c99769d&scoped=true"
import script from "./order_link.vue?vue&type=script&lang=js"
export * from "./order_link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c99769d",
  null
  
)

export default component.exports